import { genericLab } from './Lab/flow';

const GenericFlows = { genericLab };
export default GenericFlows;
